import styled from 'styled-components';

export const MainVideoArea = styled.div`
  display: flex;
  justify-content: center;
`;

export const ThumbsArea = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;
